<template>
  <div :class="$style.root">
    <PagesNewsletterComponent :class="$style.newsletter" />
  </div>
</template>

<script lang="ts" setup>
definePageMeta({
  layout: 'newsletter'
})

useHead({
  htmlAttrs: {
    'data-page-type': 'newsletter'
  }
})
</script>

<style module>
.root {
  display: flex;
  flex-direction: column;
  justify-content: center;

  position: relative;
}

.newsletter {
  composes: container from global;
}
</style>
